"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AppSettings_1 = tslib_1.__importDefault(require("../apiServices/auth/AppSettings"));
var SceType_1 = require("../typeServices/modelService/SceType");
var SceFeatures_1 = require("../typeServices/sceFeatures/SceFeatures");
var SceFunction_1 = require("../typeServices/functionTypeService/SceFunction");
var SceInstance_1 = require("../typeServices/instanceService/SceInstance");
var SceAssets_1 = require("../typeServices/assetsService/SceAssets");
var Permissions_1 = require("../apiServices/rbac/permissions/Permissions");
var UserPermissions_1 = require("../apiServices/rbac/group/UserPermissions");
var FunctionsLibrary_1 = require("../typeServices/functionLibrary/FunctionsLibrary");
var AlarmType_1 = require("../typeServices/alarmService/AlarmType");
var Sce = /** @class */ (function () {
    function Sce() {
        this._sceAssets = new SceAssets_1.SceAssets();
        this._sceFeatures = new SceFeatures_1.SceFeatures();
        this._sceFunction = new SceFunction_1.SceFunction();
        this._sceInstance = new SceInstance_1.SceInstance();
        this._sceType = new SceType_1.SceType();
        this._functionsLibrary = new FunctionsLibrary_1.FunctionsLibrary();
        this._alarmType = new AlarmType_1.AlarmType();
    }
    Sce.createSce = function () {
        return new Sce();
    };
    //#region Sce
    Sce.prototype.init = function (dataProviderUrl, productVariantName, skipAthentication, permissions, authScheme) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                AppSettings_1.default.init(dataProviderUrl, productVariantName, skipAthentication, authScheme);
                Permissions_1.rbacPermissions.loadAvailablePermissions(permissions);
                return [2 /*return*/];
            });
        });
    };
    Sce.prototype.hasPermission = function (method) {
        return UserPermissions_1.userPermissions.hasPermission(method);
    };
    //#endregion
    //#region SceAssets
    Sce.prototype.getSystems = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.getSystems()];
                }
            });
        });
    };
    Sce.prototype.getEdges = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.getEdges()];
                }
            });
        });
    };
    Sce.prototype.getDevicesConnectivityType = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.getDevicesConnectivityType()];
                }
            });
        });
    };
    Sce.prototype.getStructures = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.getStructures()];
                }
            });
        });
    };
    Sce.prototype.getVariables = function (objectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.getVariables(objectId)];
                }
            });
        });
    };
    Sce.prototype.getObjectByEdge = function (objectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.getObjectByEdge(objectId)];
                }
            });
        });
    };
    Sce.prototype.getObjectByEdgeWithPaging = function (objectId, count, pageNumber, pageSize) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.getObjectByEdgeWithPaging(objectId, count, pageNumber, pageSize)];
                }
            });
        });
    };
    Sce.prototype.systemStructureObjectsDetails = function (systemId, modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.systemStructureObjectsDetails(systemId, modelId)];
                }
            });
        });
    };
    Sce.prototype.systemStructureChildObjectsDetails = function (objectId, modleId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.systemStructureChildObjectsDetails(objectId, modleId)];
                }
            });
        });
    };
    Sce.prototype.systemStructureObjects = function (systemId, modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.systemStructureObjects(systemId, modelId)];
                }
            });
        });
    };
    Sce.prototype.systemStructureChildObjects = function (systemId, modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.systemStructureChildObjects(systemId, modelId)];
                }
            });
        });
    };
    Sce.prototype.querySystemStructureObjects = function (modelId, query, all, amInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.querySystemStructureObjects(modelId, query, all, amInfo)];
                }
            });
        });
    };
    Sce.prototype.queryStructureObjectsPaging = function (modelId, query, all, amInfo, count, pageNumber, pageSize) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.queryStructureObjectsPaging(modelId, query, all, amInfo, count, pageNumber, pageSize)];
                }
            });
        });
    };
    Sce.prototype.getSystemStructureModels = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.getSystemStructureModels()];
                }
            });
        });
    };
    Sce.prototype.getConnectDetailsFromIdentityModels = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.getConnectDetailsFromIdentityModels()];
                }
            });
        });
    };
    Sce.prototype.getSystemsBasedOnConnectModel = function (modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.getSystemsBasedOnConnectModel(modelId)];
                }
            });
        });
    };
    Sce.prototype.getChildObjects = function (query, groupBy, nameLookupModel, groupingIdentifier, all, aminfo, pageNumber, pageSize) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.getChildObjects(query, groupBy, nameLookupModel, groupingIdentifier, all, aminfo, pageNumber, pageSize)];
                }
            });
        });
    };
    Sce.prototype.getChildObjectsST = function (query, groupBy, nameLookupModel, groupingIdentifier, all, aminfo, pageNumber, pageSize) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.getChildObjectsST(query, groupBy, nameLookupModel, groupingIdentifier, all, aminfo, pageNumber, pageSize)];
                }
            });
        });
    };
    Sce.prototype.filterObjects = function (query, groupBy, nameLookupModel, groupingIdentifier, all, amInfo, filterOptions, pageNumber, pageSize) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.filterObjects(query, groupBy, nameLookupModel, groupingIdentifier, all, amInfo, filterOptions, pageNumber, pageSize)];
                }
            });
        });
    };
    Sce.prototype.filterSystemStructureObjects = function (model, pageNumber, pageSize, query, all, amInfo, filterOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.filterSystemStructureObjects(model, pageNumber, pageSize, query, all, amInfo, filterOptions)];
                }
            });
        });
    };
    Sce.prototype.filterEdgeObjects = function (edgeId, pageNumber, pageSize, filterOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.filterEdgeObjects(edgeId, pageNumber, pageSize, filterOptions)];
                }
            });
        });
    };
    Sce.prototype.getAssetTypes = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.getAssetTypes()];
                }
            });
        });
    };
    Sce.prototype.getAssetModelTypes = function (objectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.getAssetModelTypes(objectId)];
                }
            });
        });
    };
    Sce.prototype.deleteObject = function (objectId, modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.deleteObject(objectId, modelId)];
                }
            });
        });
    };
    Sce.prototype.createStrucutreModel = function (name, modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.createStrucutreModel(name, modelId)];
                }
            });
        });
    };
    Sce.prototype.editStrucutreModel = function (name, modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.editStrucutreModel(name, modelId)];
                }
            });
        });
    };
    Sce.prototype.deleteStrucutreModel = function (modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.deleteStrucutreModel(modelId)];
                }
            });
        });
    };
    Sce.prototype.cloneStrucutreModel = function (clonedStrucutreName, clonedStrucutreModelId, originSourceId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.cloneStrucutreModel(clonedStrucutreName, clonedStrucutreModelId, originSourceId)];
                }
            });
        });
    };
    Sce.prototype.getSystemStructureModelNamesAndIdsForTenantExt = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.getSystemStructureModelNamesAndIdsForTenantExt()];
                }
            });
        });
    };
    Sce.prototype.getSystemStructureModelNamesAndIdsForTenantExt2 = function (systemId, groupingIdentifier) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.getSystemStructureModelNamesAndIdsForTenantExt2(systemId, groupingIdentifier)];
                }
            });
        });
    };
    Sce.prototype.getSystemStructureModelsForSpecificTenant = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.getSystemStructureModelsForSpecificTenant()];
                }
            });
        });
    };
    Sce.prototype.addStrucutreNode = function (parentObjectId, objectId, structureModelId, name, originStructureModelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.addStrucutreNode(parentObjectId, objectId, structureModelId, name, originStructureModelId)];
                }
            });
        });
    };
    Sce.prototype.editStrucutreNodeName = function (newName, objectId, structureModelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.editStrucutreNodeName(newName, objectId, structureModelId)];
                }
            });
        });
    };
    Sce.prototype.deleteStrucutreNode = function (modelId, objectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceAssets.deleteStrucutreNode(modelId, objectId)];
                }
            });
        });
    };
    //#endregion
    //#region SceFeatures
    Sce.prototype.getTitleLabel = function () {
        return this._sceFeatures.getTitleLabel();
    };
    Sce.prototype.isConditionSupported = function () {
        return this._sceFeatures.isConditionSupported();
    };
    Sce.prototype.getTypeLabel = function () {
        return this._sceFeatures.getTypeLabel();
    };
    Sce.prototype.isDeveloper = function () {
        return this._sceFeatures.isDeveloper();
    };
    //#endregion
    //#region SceFunction
    Sce.prototype.getFunctionsList = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceFunction.getFunctionsList()];
                }
            });
        });
    };
    Sce.prototype.getTypeDetails = function (model, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceFunction.getTypeDetails(model, typeId, version)];
                }
            });
        });
    };
    Sce.prototype.saveFunction = function (model, modelJson, tags) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceFunction.saveFunction(model, modelJson, tags)];
                }
            });
        });
    };
    Sce.prototype.importFunctionTypes = function (jsons) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceFunction.importFunctionTypes(jsons)];
                }
            });
        });
    };
    // Check if used by UI or remove it
    Sce.prototype.getFunction = function (modelId, typeId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceFunction.getFunction(modelId, typeId)];
                }
            });
        });
    };
    Sce.prototype.deleteFunction = function (modelId, typeId, tags) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceFunction.deleteFunction(modelId, typeId, tags)];
                }
            });
        });
    };
    Sce.prototype.getFunctionType = function (model, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceFunction.getFunctionType(model, typeId, version)];
                }
            });
        });
    };
    Sce.prototype.getFunctionTypes = function (typeInformation) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceFunction.getFunctionTypes(typeInformation)];
                }
            });
        });
    };
    Sce.prototype.verifyFunctionExists = function (typeId, name) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceFunction.verifyFunctionExists(typeId, name)];
                }
            });
        });
    };
    //#endregion
    //#region SceType
    Sce.prototype.getTypes = function (models) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.getTypes(models)];
                }
            });
        });
    };
    Sce.prototype.getObjectTypeDetails = function (model, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.getObjectTypeDetails(model, typeId, version)];
                }
            });
        });
    };
    Sce.prototype.saveModel = function (model, isCod) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.saveModel(model, isCod)];
                }
            });
        });
    };
    Sce.prototype.getModels = function (typeId, isCod) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.getModels(typeId, isCod)];
                }
            });
        });
    };
    Sce.prototype.deleteModel = function (model, isCod) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.deleteModel(model, isCod)];
                }
            });
        });
    };
    Sce.prototype.getSupportedModels = function (excludeEngineeringData) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.getSupportedModels(excludeEngineeringData)];
                }
            });
        });
    };
    Sce.prototype.getModelStatistics = function (pageNumber, pageSize, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.getModelStatistics(pageNumber, pageSize, typeId, version)];
                }
            });
        });
    };
    Sce.prototype.getTypesVersions = function (data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.getTypesVersions(data)];
                }
            });
        });
    };
    Sce.prototype.importModels = function (zippedModels, parentObjectType, isCod) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.importModels(zippedModels, parentObjectType, isCod)];
                }
            });
        });
    };
    Sce.prototype.createExportableModels = function (models) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.createExportableModels(models)];
                }
            });
        });
    };
    Sce.prototype.createImportableModel = function (zippedModel, targetAssociatedObjectType) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this._sceType.createImportableModel(zippedModel, targetAssociatedObjectType)];
            });
        });
    };
    Sce.prototype.getTypeVersions = function (data, filterByMajorVersion) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.getTypeVersions(data, filterByMajorVersion)];
                }
            });
        });
    };
    Sce.prototype.getAlarmType = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.getAlarmType()];
                }
            });
        });
    };
    Sce.prototype.getType = function (modelId, typeId, version, objectId, isCod) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.getType(modelId, typeId, version, objectId, isCod)];
                }
            });
        });
    };
    Sce.prototype.getTypeDefinition = function (modelId, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.getTypeDefinition(modelId, typeId, version)];
                }
            });
        });
    };
    Sce.prototype.getSupportedConditionMonitorModels = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.getSupportedConditionMonitorModels()];
                }
            });
        });
    };
    Sce.prototype.verifyTypeExists = function (modelId, typeId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.verifyTypeExists(modelId, typeId)];
                }
            });
        });
    };
    Sce.prototype.getModelsAndTypesBySCEModelIdWithTypeInfo = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.getModelsAndTypesBySCEModelIdWithTypeInfo()];
                }
            });
        });
    };
    Sce.prototype.getVariablesAlarmsAndEvents = function (modelId, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.getVariablesAlarmsAndEvents(modelId, typeId, version)];
                }
            });
        });
    };
    Sce.prototype.getAllModels = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.getAllModels()];
                }
            });
        });
    };
    Sce.prototype.getFunctionEndpointList = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.getFunctionEndpointList()];
                }
            });
        });
    };
    Sce.prototype.addFunctionEndpoint = function (endPoint) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.addFunctionEndpoint(endPoint)];
                }
            });
        });
    };
    Sce.prototype.deleteFunctionEndpoint = function (endPoint) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.deleteFunctionEndpoint(endPoint)];
                }
            });
        });
    };
    Sce.prototype.getTypeVariables = function (model, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.getTypeVariables(model, typeId, version)];
                }
            });
        });
    };
    Sce.prototype.getModelDefinition = function (modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.getModelDefinition(modelId)];
                }
            });
        });
    };
    Sce.prototype.getSupportedCondintionModelWithTenantInfo = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.getSupportedCondintionModelWithTenantInfo()];
                }
            });
        });
    };
    Sce.prototype.addNewConditionMonitorModels = function (modelList) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.addNewConditionMonitorModels(modelList)];
                }
            });
        });
    };
    Sce.prototype.updateConditionMonitorModels = function (modelList) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.updateConditionMonitorModels(modelList)];
                }
            });
        });
    };
    Sce.prototype.removeConditionMonitorModels = function (modelIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.removeConditionMonitorModels(modelIds)];
                }
            });
        });
    };
    Sce.prototype.getFunctionVersionsForType = function (modelId, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.getFunctionVersionsForType(modelId, typeId, version)];
                }
            });
        });
    };
    Sce.prototype.getLatestFunctionsForType = function (modelId, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.getLatestFunctionsForType(modelId, typeId, version)];
                }
            });
        });
    };
    Sce.prototype.getTenantSpecificType = function (modelId, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.getTenantSpecificType(modelId, typeId, version)];
                }
            });
        });
    };
    Sce.prototype.getAssetMonitorTypesInfoForFunctionType = function (functionTypeId, functionVersion) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.getAssetMonitorTypesInfoForFunctionType(functionTypeId, functionVersion)];
                }
            });
        });
    };
    //#endregion
    //#region SceInstance
    Sce.prototype.monitorMultipleInstances = function (models, objectToSceModuleIds, isCod) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceInstance.monitorMultipleInstances(models, objectToSceModuleIds, isCod)];
                }
            });
        });
    };
    Sce.prototype.updateExistingInstances = function (models, objectToSceModuleIds, isCod) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceInstance.updateExistingInstances(models, objectToSceModuleIds, isCod)];
                }
            });
        });
    };
    Sce.prototype.getInstance = function (objectId, assetMonitorModelId, isCod) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceInstance.getInstance(objectId, assetMonitorModelId, isCod)];
                }
            });
        });
    };
    Sce.prototype.deleteMultipleInstances = function (objectsInfo, isCod) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceInstance.deleteMultipleInstances(objectsInfo, isCod)];
                }
            });
        });
    };
    Sce.prototype.disableSingleOrMultipleMonitoringInstances = function (data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceInstance.disableSingleOrMultipleMonitoringInstances(data)];
                }
            });
        });
    };
    Sce.prototype.enableSingleOrMultipleMonitoringInstances = function (data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceInstance.enableSingleOrMultipleMonitoringInstances(data)];
                }
            });
        });
    };
    Sce.prototype.restoreSce = function (edgeId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceInstance.restoreSce(edgeId)];
                }
            });
        });
    };
    Sce.prototype.getInfoModelInstances = function (modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceInstance.getInfoModelInstances(modelId)];
                }
            });
        });
    };
    Sce.prototype.getSCECleanupInstances = function (edgeId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceInstance.getSCECleanupInstances(edgeId)];
                }
            });
        });
    };
    Sce.prototype.updateInfoModelInstance = function (objectId, modelId, value) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceInstance.updateInfoModelInstance(objectId, modelId, value)];
                }
            });
        });
    };
    Sce.prototype.saveInfoModelInstance = function (value) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceInstance.saveInfoModelInstance(value)];
                }
            });
        });
    };
    Sce.prototype.deleteInfoModelInstance = function (objectId, modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceInstance.deleteInfoModelInstance(objectId, modelId)];
                }
            });
        });
    };
    Sce.prototype.updateRelatedInstances = function (functionType) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceInstance.updateRelatedInstances(functionType)];
                }
            });
        });
    };
    Sce.prototype.updateTypeRelatedInstances = function (typeInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceInstance.updateTypeRelatedInstances(typeInfo)];
                }
            });
        });
    };
    Sce.prototype.getObjectVariables = function (objectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceInstance.getObjectVariables(objectId)];
                }
            });
        });
    };
    //#endregion
    //#region Functions Library
    Sce.prototype.createLibrary = function (libraryName, libraryPassword, withIPProtection) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.createLibrary(libraryName, libraryPassword, withIPProtection)];
                }
            });
        });
    };
    Sce.prototype.addFunctionsToNewLibrary = function (libraryDetails, withIPProtection) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.addFunctionsToNewLibrary(libraryDetails, withIPProtection)];
                }
            });
        });
    };
    Sce.prototype.addFunctionsToExistingLibrary = function (libraryDetails, withIPProtection) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.addFunctionsToExistingLibrary(libraryDetails, withIPProtection)];
                }
            });
        });
    };
    Sce.prototype.removeFunctionsFromExistingLibrary = function (libraryDetails, withIPProtection) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.removeFunctionsFromExistingLibrary(libraryDetails, withIPProtection)];
                }
            });
        });
    };
    Sce.prototype.deleteLibrary = function (libraryId, libraryVersion, password, withIPProtection) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.deleteLibrary(libraryId, libraryVersion, password, withIPProtection)];
                }
            });
        });
    };
    Sce.prototype.deleteLibraryNew = function (libraryId, libraryVersion, password, withIPProtection, deleteFunctions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.deleteLibraryNew(libraryId, libraryVersion, password, withIPProtection, deleteFunctions)];
                }
            });
        });
    };
    Sce.prototype.getLibraryAndNodes = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.getLibraryAndNodes()];
                }
            });
        });
    };
    Sce.prototype.getMutuallyExclusiveFunctionTypes = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.getMutuallyExclusiveFunctionTypes()];
                }
            });
        });
    };
    Sce.prototype.getExportableFunctions = function (exportableInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.getExportableFunctions(exportableInfo)];
                }
            });
        });
    };
    Sce.prototype.getExportableTypes = function (models) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.getExportableTypes(models)];
                }
            });
        });
    };
    Sce.prototype.importFunctions = function (libraryInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.importFunctions(libraryInfo)];
                }
            });
        });
    };
    Sce.prototype.importFunctionsWithLibrary = function (libraryInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.importFunctionsWithLibrary(libraryInfo)];
                }
            });
        });
    };
    Sce.prototype.validateLibImport = function (libraryInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.validateLibImport(libraryInfo)];
                }
            });
        });
    };
    Sce.prototype.validateLibImportWithLibrary = function (libraryInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.validateLibImportWithLibrary(libraryInfo)];
                }
            });
        });
    };
    Sce.prototype.importTypes = function (models) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.importTypes(models)];
                }
            });
        });
    };
    Sce.prototype.validateTypeImport = function (models) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.validateTypeImport(models)];
                }
            });
        });
    };
    Sce.prototype.getDecryptedFunctionType = function (libraryId, libraryVersion, password, functionInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.getDecryptedFunctionType(libraryId, libraryVersion, password, functionInfo)];
                }
            });
        });
    };
    Sce.prototype.updateIPProtectedFunction = function (libraryId, libraryVersion, password, functionInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.updateIPProtectedFunction(libraryId, libraryVersion, password, functionInfo)];
                }
            });
        });
    };
    Sce.prototype.getLibraryReferencesForFunctionTypes = function (functionTypes) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.getLibraryReferencesForFunctionTypes(functionTypes)];
                }
            });
        });
    };
    Sce.prototype.getFunctionTypeWithEncryptionStatus = function (modelId, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.getFunctionTypeWithEncryptionStatus(modelId, typeId, version)];
                }
            });
        });
    };
    Sce.prototype.getTypeLatestFunctionDataWithEncryption = function (modelId, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.getTypeLatestFunctionDataWithEncryption(modelId, typeId, version)];
                }
            });
        });
    };
    Sce.prototype.convertToIPProtectedLibrary = function (libraryId, libraryVersion, password) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.convertToIPProtectedLibrary(libraryId, libraryVersion, password)];
                }
            });
        });
    };
    Sce.prototype.CreateAndAssociateFunctionToLib = function (libraryId, libraryVersion, password, functionTypeDetails) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.CreateAndAssociateFunctionToLib(libraryId, libraryVersion, password, functionTypeDetails)];
                }
            });
        });
    };
    Sce.prototype.ChangeLibraryPassword = function (libraryDetails, withIPProtection) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.ChangeLibraryPassword(libraryDetails, withIPProtection)];
                }
            });
        });
    };
    Sce.prototype.UnlockLibrary = function (libraryDetails, withIPProtection) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.UnlockLibrary(libraryDetails, withIPProtection)];
                }
            });
        });
    };
    Sce.prototype.deleteEncryptedFunctionType = function (libraryId, libraryVersion, password, modelId, typeId, tags) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.deleteEncryptedFunctionType(libraryId, libraryVersion, password, modelId, typeId, tags)];
                }
            });
        });
    };
    Sce.prototype.renameLibrary = function (libraryId, libraryVersion, password, name) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.renameLibrary(libraryId, libraryVersion, password, name)];
                }
            });
        });
    };
    Sce.prototype.verifyLibraryExists = function (name) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.verifyLibraryExists(name)];
                }
            });
        });
    };
    Sce.prototype.getLibraryDetails = function (libraryId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._functionsLibrary.getLibraryDetails(libraryId)];
                }
            });
        });
    };
    Sce.prototype.getAlarmProperties = function (modelId, alarmId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._alarmType.getAlarmProperties(modelId, alarmId, version)];
                }
            });
        });
    };
    Sce.prototype.getAlarms = function (modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._alarmType.getAlarms(modelId)];
                }
            });
        });
    };
    Sce.prototype.getEventProperties = function (modelId, eventId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._alarmType.getEventProperties(modelId, eventId, version)];
                }
            });
        });
    };
    Sce.prototype.getEvents = function (modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._alarmType.getEvents(modelId)];
                }
            });
        });
    };
    //#endregion
    Sce.prototype.validateToken = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                // Not needed as it's been handled in @iaedge/auth library. Will be removed after confirmation
                return [2 /*return*/, Promise.resolve()];
            });
        });
    };
    Sce.prototype.getEnggSceModels = function (models) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._sceType.getEnggSceModels(models)];
                }
            });
        });
    };
    return Sce;
}());
exports.Sce = Sce;
var sce = Sce.createSce();
exports.default = sce;
//# sourceMappingURL=Sce.js.map